export const navigateTo = (url) => {
  window.location.assign(url);
};
